/**
 * Bloc « Ils ont acheté un vélo MINT » (avis Trustpilot, `snippets/trustpilot-reviews.liquid`)
 * — tracking du clic sur un lien d'avis, en `click_cta`.
 *
 * Écouteur DÉLÉGUÉ, unique, posé sur `document` : le bloc peut avoir deux instances
 * sur la même page (accueil en `mode: 'cards'`, bandeau vert en `mode: 'rating'`,
 * T11), et un écouteur par carte serait reposé à chaque re-render de section.
 *
 * Sélecteur `[data-tp-review-link]` — STRICTEMENT distinct de `[data-tp-fallback]`
 * (écouteur de `trustpilot-fallback.liquid:111-138`, qui pousse déjà
 * `trustpilot_fallback_click` avec `link_location`). Aucun élément ne porte les
 * deux attributs à la fois : ce composant ne risque donc pas de faire remonter le
 * fallback en plus de son propre event sur un même clic.
 *
 * Garde anti-double-init sur le modèle de `reconditionnement-mint.js:82-83` — le
 * script est émis par le snippet lui-même, donc potentiellement deux fois sur la
 * même page (deux instances = deux balises <script src="…"> et le navigateur
 * exécute chacune).
 *
 * Pas de réinit sur `shopify:section:load` : l'écouteur est posé une seule fois
 * sur `document` et la délégation par `closest()` couvre nativement tout élément
 * injecté ensuite par l'éditeur de sections — reposer l'écouteur au même endroit
 * serait du code mort (il n'y a rien à réinitialiser par instance ici).
 */
(function () {
  'use strict';

  if (window.__tpReviewsInit) return;
  window.__tpReviewsInit = true;

  function pushEvent(name, data) {
    if (typeof window.trackEvent === 'function') {
      window.trackEvent(name, data);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data));
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('[data-tp-review-link]');
    if (!link) return;

    var root = link.closest('[data-tp-reviews-mode]');

    // `click_cta`, event déjà relayé par GTM : un event dédié n'arriverait pas dans GA4 sans
    // tag. Le lien porte `data-cta-name`, ce qui écarte le tracker générique (pas de doublon).
    pushEvent('click_cta', {
      cta_name: link.getAttribute('data-cta-name') || 'trustpilot_avis',
      cta_location: 'trustpilot_' + (link.dataset.tpPosition || (root ? root.dataset.tpReviewsMode : '')),
    });
  });
})();
